import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function TabPanel(props) {
  const { children, value, index, boxSx, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={boxSx}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({ children, boxSx, onChangeTab }) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onChangeTab && onChangeTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {React.Children.map(children,
            (child, index) => {
              return <Tab label={child.props.label} key={`BasicTabs_Tabs_${child.props.label}`} {...a11yProps({ index })} />
            })
          }
        </Tabs>
      </Box>
      {React.Children.map(children,
        (child, index) => {
          return (
            <TabPanel boxSx={boxSx} value={value} index={index} key={`BasicTabs_TabPanel_${index}`}>
              {child}
            </TabPanel>
          )
        })
      }
    </Box>
  );
}
